import { render, staticRenderFns } from "./ChartRunningWidgetVLR.vue?vue&type=template&id=2ddec65a&scoped=true&"
import script from "./ChartRunningWidgetVLR.vue?vue&type=script&lang=ts&"
export * from "./ChartRunningWidgetVLR.vue?vue&type=script&lang=ts&"
import style0 from "./ChartRunningWidgetVLR.vue?vue&type=style&index=0&id=2ddec65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddec65a",
  null
  
)

export default component.exports